import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "components/LoadingSpinner";
import { useAuth } from "./auth/AuthContext";
import logo from "./assets/logo.png";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Container,
} from "reactstrap";
import axios from "axios";

// ✅ env
const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(/\/+$/, "");
const API_LOGIN = `${API_BASE}/users/login`;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const mainContent = useRef(null);

  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.body.classList.add("no-sidebar");
    return () => document.body.classList.remove("no-sidebar");
  }, []);

  useEffect(() => {
    document.body.classList.add("bg-default");
    return () => document.body.classList.remove("bg-default");
  }, []);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const onSignIn = async () => {
    if (isLoading) return;

    if (!API_BASE) {
      setErr("ไม่ได้ตั้งค่า REACT_APP_API_BASE ในไฟล์ .env");
      return;
    }

    const u = username.trim();
    const p = password.trim();
    if (!u || !p) {
      setErr("กรุณากรอก Username และ Password");
      return;
    }

    setErr("");
    setIsLoading(true);

    try {
      // ✅ ใช้ axios ตรง ไม่ผ่าน middleware api
      const res = await axios.post(
        API_LOGIN,
        { username: u, password: p },
        { headers: { "Content-Type": "application/json" } },
      );

      const data = res?.data || {};

      const accessToken =
        data?.accessToken ||
        data?.token ||
        data?.jwt ||
        data?.data?.accessToken ||
        null;

      const rawUser = data?.user || data?.data?.user || data?.data || {};

      const userObj = {
        ...rawUser,
        username: rawUser?.username || u,
        avatar: rawUser?.avatar || null,
      };

      // ✅ ไม่แยก role → ส่ง "user" คงที่
      login(accessToken, "user", userObj);

      navigate("/customer-report", { replace: true });
    } catch (error) {
      console.error("Auth failed:", error);
      setErr(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message,
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <LoadingSpinner fullPage />;

  return (
    <>
      <div
        className="main-content login-bg d-flex align-items-center justify-content-center"
        ref={mainContent}
        style={{
          minHeight: "100vh",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.50)",
            zIndex: 0,
          }}
        />

        <Container fluid>
          <Row className="justify-content-center">
            <Col lg="5" md="7">
              <Card
                className="shadow border-0"
                style={{
                  zIndex: 1,
                  width: "100%",
                  maxWidth: 1080,
                  borderRadius: 16,
                  backgroundColor: "#ffffff",
                }}
              >
                <CardBody className="px-lg-5">
                  <Row className="justify-content-center text-center mb-3">
                    <Col>
                      <div className="px-4 py-4 text-center">
                        <img
                          src={logo}
                          alt="iFMS Reports"
                          style={{
                            width: 480,
                            maxWidth: "100%",
                            height: "auto",
                          }}
                        />
                      </div>
                    </Col>
                  </Row>

                  {err && (
                    <div className="text-danger text-center mb-3">{err}</div>
                  )}

                  <Form
                    role="form"
                    onSubmit={(e) => {
                      e.preventDefault();
                      onSignIn();
                    }}
                  >
                    <FormGroup className="mb-3">
                      <label className="form-control-label mb-1">
                        Username
                      </label>
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-email-83" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Username"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          autoComplete="off"
                          autoCorrect="off"
                          spellCheck="false"
                        />
                      </InputGroup>
                    </FormGroup>

                    <FormGroup>
                      <label className="form-control-label mb-1">
                        Password
                      </label>
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-lock-circle-open" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Password"
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          autoComplete="new-password"
                          autoCorrect="off"
                          spellCheck="false"
                        />
                      </InputGroup>
                    </FormGroup>

                    <div className="text-center d-flex justify-content-center">
                      <Button
                        className="my-4"
                        color="primary"
                        type="submit"
                        style={{ minWidth: 160 }}
                      >
                        Log In
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Login;
